import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';


import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {setComponentState,setSidebarState} from '../../actions/Builder.js';

import SidebarElementSpacing from './SidebarElementSpacing.js';
import LinkPicker from './LinkPicker.js';
import AlignPicker from './AlignPicker.js';
import ColorPicker from './ColorPicker.js';
import BorderPicker from './BorderPicker.js';

import PaddingPicker from './PaddingPicker.js';
import SidebarElementWrapper from './SidebarElementWrapper.js';
import SidebarElementSetting from './SidebarElementSetting.js';
import SidebarSettingAccordion from './SidebarSettingAccordion.js';

import SidebarElementHeader from './SidebarElementHeader.js';

class Button extends React.Component {
	constructor(props) {	
		super(props);
		this.onPaddingChange = this.onPaddingChange.bind(this);
		this.el = this.el.bind(this);	
		this.handleBackClick = this.handleBackClick.bind(this);
		this.onChange = this.onChange.bind(this);
		this.componentDidMount = this.componentDidMount.bind(this);
		this.handleLinkChange = this.handleLinkChange.bind(this);
		this.handleAlignChange = this.handleAlignChange.bind(this);
		this.handleBorderChange = this.handleBorderChange.bind(this);
		
	}

	handleAlignChange(id,s) {
		this.props.setComponentState(this.el().id,{'align':s});
	}

	handleLinkChange(id,s) {

		this.props.setComponentState(this.el().id,s);
	}

	onPaddingChange(id,padding) {
		let changes = {};
    	changes[id] = padding;    	
		this.props.setComponentState(this.el().id,changes);
    }


    el() {
    	return this.props.builder.components[this.props.id];
    }

    handleBackClick() {
    	this.props.setSidebarState({'visible':false});
    }

    onChange(v) {
    	this.props.setComponentState(this.el().id,{value:v.target.value});
    }

    handleBorderChange(id,border) {
    	let changes = {};
    	changes[id] = border;    	
    	
    	this.props.setComponentState(this.el().id,changes);
    }



    

	componentDidMount() {
		
	}

    render() {
    	if(this.props.sidebar == true) {
    		return(
	    		<div className="sidebar text" style={this.props.style}>
	    			<SidebarElementHeader handleBackClick={this.handleBackClick} text="Button" />
	    			
	    			<div className="panel-group panel-group-continuous" id="button-settings" aria-multiselectable="true" role="tablist">

            			<SidebarSettingAccordion selectedSetting={false} optionKey="button" parent="button-settings" title="Button">
            				<SidebarElementSetting text="Text">
								<input type="text" value={this.el().value} onChange={this.onChange} className="form-control" />
							</SidebarElementSetting>

							<SidebarElementSetting text="Border">
								<BorderPicker id='border' handleBorderChange={this.handleBorderChange} data={this.el().border} />
							</SidebarElementSetting>

							<SidebarElementSetting text="Background color">
								<ColorPicker transparent={true} id='backgroundColor' color={this.el().backgroundColor} handleColorChange={this.handleBorderChange} />
							</SidebarElementSetting>

							<SidebarElementSetting text="Text color">
								<ColorPicker transparent={false} id='color' color={this.el().color} handleColorChange={this.handleBorderChange} />
							</SidebarElementSetting>

							<SidebarElementSetting text="Horizontal position">
								<AlignPicker id="align" align={this.el().align} handleChange={this.handleAlignChange}/>
							</SidebarElementSetting>

            			</SidebarSettingAccordion>

            			<SidebarSettingAccordion selectedSetting={false} optionKey="link" parent="button-settings" title="Link">
            				<SidebarElementSetting text="Link">
								<LinkPicker onlyPickUrl={true} handleLinkChange={this.handleLinkChange} data={this.props.builder.components[this.props.id]} />
							</SidebarElementSetting>
            			</SidebarSettingAccordion>

            			<SidebarSettingAccordion selectedSetting={false} optionKey="spacing" parent="button-settings" title="Spacing">
            				<SidebarElementSetting text="Padding">
								<PaddingPicker id='padding' handlePaddingChange={this.onPaddingChange} data={this.el().padding} />
							</SidebarElementSetting>
						</SidebarSettingAccordion>

            		</div>
	    		</div>


    		);
    	}else{
    		let button_style = {
				border:this.el().border.replace(/\|/g,' '),
				backgroundColor:this.el().backgroundColor,
				color:this.el().color ? this.el().color : '#ffffff',
			};

    		return (
    			<table className="table-block" style={{width:'100%'}}>
    				<tbody>
    					<tr>
	    					<td style={{textAlign:this.el().align,padding:this.el().padding}}>
	    						<a className="click-button" style={button_style} href="javascript:void(0)">{this.el().value}</a>
	    					</td>
    					</tr>
    				</tbody>
    			</table>
	      		
	      );
    	}
      
    }
}
const mapStateToProps = (state) => {
	return {
		builder:state.builder
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({setComponentState,setSidebarState},dispatch)
}

Button = connect(mapStateToProps,mapDispatchToProps)(Button);

export default Button;





// WEBPACK FOOTER //
// ./components/builder/Button.js